import React, { useState, MouseEvent } from 'react';

import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';
import LanguageIcon from '@mui/icons-material/Language';

import { useMytaverse } from '@providers/MytaverseProvider';
import { getAiAssistantLanguageOptions } from '@helpers/assistant';
import { env } from 'env';

import { classes } from './styles';

const { REACT_APP_FEATURE_SHOW_LANGUAGE = 'true' } = env;
const showLanguage = REACT_APP_FEATURE_SHOW_LANGUAGE === 'true';

const LoginLanguageSwitcher = () => {
  const { appSettings, selectLanguage, selectedLanguage } = useMytaverse();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const languageOptions = getAiAssistantLanguageOptions(
    appSettings?.aiAssistant,
  );

  if (!showLanguage || !languageOptions?.length) {
    return null;
  }

  const open = !!anchorEl;
  const current =
    languageOptions.find((opt) => opt.key === selectedLanguage) ??
    languageOptions[0];

  const handleOpen = (e: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (key: string) => {
    selectLanguage(key);
    handleClose();
  };

  return (
    <>
      <Tooltip title={current.label}>
        <IconButton
          aria-label="select language"
          aria-controls={open ? 'login-language-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open}
          onClick={handleOpen}
          disableRipple
          sx={classes.button}
        >
          <LanguageIcon sx={classes.icon} />
        </IconButton>
      </Tooltip>
      <Menu
        id="login-language-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        MenuListProps={{ sx: classes.menuList }}
        slotProps={{ paper: { sx: classes.menuPaper } }}
      >
        {languageOptions.map(({ key, label }) => (
          <MenuItem
            key={key}
            lang={key}
            selected={key === current.key}
            onClick={() => handleSelect(key)}
            sx={classes.menuItem}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LoginLanguageSwitcher;
